import PageWrapper from './PageWrapper.component';

export default PageWrapper;
